/**
 * Set when the retailer views the tooltip for the Insider Free Shipping Threshold coverage badge
 */ export var INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN = 'INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN';
